module.exports =
{
    createPopup: 
    {

        modals: 
        {

            terms: 
            {
                display: 'flex', 
                colour: '#EBF8FD',
                width: "380px",
                invertCross: true,
            },
            
        },
        selected_modal: "",
        
        _init: function ()
        {
            this.setupModal()
            
        },
        modalResize: function () {
            $(`#modal-${this.selected_modal}`)?.css("height", this.modals[this.selected_modal].height * Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0))
        },
        showModal: function(modal){
            
            let this_class = this
            Object.keys(this.modals).forEach(function(key){
                if(key == modal){
                    $("#modal-" + key)?.css("display", this_class.modals[key].display)
                    $("#modal-box")?.css("background-color", this_class.modals[key].colour)
  
                    if(this_class.modals[key].width){
                        $("#modal-box")?.css("width", this_class.modals[key].width)
                    }
                    if(this_class.modals[key].maxWidth){
                        $("#modal-box")?.css("max-width", this_class.modals[key].maxWidth)
                    }
                    if(this_class.modals[key].invertCross){
                        $(".modal-close > img")?.attr("src", "/includes/assets/images/modal-cross-black.png");
                    }
                    else{
                        $(".modal-close > img")?.attr("src", "/includes/assets/images/modal-cross.png");
                    }
                    
                    
                    $(".modal-close")?.css("background-color", this_class.modals[key].colour)

                    this_class.selected_modal = modal // set the modal that will be used in the resize listener
                    if(this_class.modals[key].height){
                        this_class.modalResize()
                    }
                }
                else{
                    $(`#modal-${key}`)?.css("display", "none")

                }
            })
            
        },
       
        
        
        resetModal: function(){
            $('body').removeClass('show-modal'); // close the modal
            //add the old close button back
            if(document.querySelector("#modal-box")?.querySelector("span")){
                document.querySelector("#modal-box").insertAdjacentHTML("afterbegin", `<span></span>`)
                $("#modal-box > span").on("click", () => {
                    $('body').removeClass('show-modal');
                })
            }
            if($("#modal-box")){
                $("#modal-box").css("width", "")
                $("#modal-box").css("max-width", "")
                $("#modal-box").css("background-color", "")
                $("#modal-box").removeClass("modal-box")
                $("#modal-box").empty()
                $("#modal-box").append("<span class></span><div id='modal-body-box'></div>")
            }
            
        },
        setupModal: function (modal){
            let light_blue = "#EBF8FD"
            let this_class = this

            document.querySelector("#modal-box")?.querySelector("span")?.remove() // remove the currect close button 
            document.querySelector("#modal-container").style.flexDirection = "column"
            document.querySelector("#modal-box").insertAdjacentHTML("afterbegin", `<div class="modal-close" style="background-color: light_blue;" ><img src="/includes/assets/images/modal-cross.png"/></div>`)
            document.querySelector("#modal-box")?.classList.add("modal-box")
            
            //setup close listeners
            $(".modal-close-button").one("click", this.resetModal, )
            $(".modal-close").one("click", this.resetModal)
            let close_observer = new MutationObserver(function(mutations) {
                if(!$('body').hasClass('show-modal')){
                    this_class.resetModal()
                    close_observer.disconnect()
                }
            })
            close_observer.observe(document.querySelector("body"), {
                attributes : true,
                attributeFilter : ['style', 'class']
            })


            this.showModal(modal)
            if(this.modals[modal].height){
                window.addEventListener("resize", () => {
                    this.modalResize()
                })
            }
        },
        
        
    },





  
}